import { Modal, ModalProps } from 'antd'
import { CSSProperties, FC, ReactNode } from 'react'

import Styles from './Modal.module.scss'

interface Props extends ModalProps {
    isModalOpen: boolean
    children: ReactNode
    size?: string
    style?: CSSProperties
    title?: string | ReactNode
}

export const BitazzaModal: FC<Props> = ({
    isModalOpen,
    children,
    size,
    style,
    title,
    ...props
}) => {
    return (
        <Modal
            centered
            title={title ? title : null}
            bodyStyle={{
                backgroundColor: '#1b1e1e',
                textAlign: 'center',
                height: size ? size : '600px',
                overflow: 'scroll',
                overflowX: 'hidden',
                padding: 0,
                ...style,
            }}
            className={Styles.container}
            {...props}
            footer={props.footer}
            open={isModalOpen}
        >
            {children}
        </Modal>
    )
}
